import { selectIsUserAuthenticated } from '../../selectors';
import { TAppState } from '../../types/appState';
import { ERequestTrigger } from '../../types/requestTrigger';

export interface IPageStateLogData {
  /** Состояние авторизации в сторе на момент запроса */
  isUserAuthenticated: boolean;
  /** Источник запроса */
  trigger?: ERequestTrigger;
  /** document.visibilityState */
  pageVisibilityState?: DocumentVisibilityState;
  /** document.hasFocus() */
  pageInFocus?: boolean;
  /** navigator.cookieEnabled */
  cookieEnabled?: boolean;
  /** Тип навигации из PerformanceNavigationTiming: navigate | reload | back_forward | prerender */
  navigationType?: string | null;
  /** Время жизни страницы в мс с момента старта навигации, performance.now() */
  pageLifetime?: number;
}

/**
 * Собирает состояние авторизации из стора, источник запроса и состояние страницы браузера для логов;
 * при ошибке чтения браузерных API возвращает только состояние авторизации и источник запроса.
 */
export function getPageStateLogData(state: TAppState, trigger?: ERequestTrigger): IPageStateLogData {
  const isUserAuthenticated = selectIsUserAuthenticated(state);

  try {
    const navigation = performance.getEntriesByType?.('navigation')[0] as PerformanceNavigationTiming | undefined;

    return {
      isUserAuthenticated,
      trigger,
      pageVisibilityState: document.visibilityState,
      pageInFocus: document.hasFocus(),
      cookieEnabled: navigator.cookieEnabled,
      navigationType: navigation?.type ?? null,
      pageLifetime: Math.round(performance.now()),
    };
  } catch {
    return { isUserAuthenticated, trigger };
  }
}
